import { t } from '../i18n.js';
import { renderPageCta, renderPageHero } from './shared.js';
import { $ } from '../utils/index.js';

const ABOUT_PRINCIPLES = [
  {
    title: 'Clarity over noise',
    body: 'We prefer clean decisions, clean interfaces, and clean execution paths.',
  },
  {
    title: 'Care without waste',
    body: 'The finish should feel considered, but the system still needs to stay fast and useful.',
  },
  {
    title: 'Long-term quality',
    body: 'We optimize for maintainability, trust, and product confidence after launch.',
  },
];

export function renderAbout(): void {
  const el = $('#page-about-us');
  if (!el) return;

  el.innerHTML = `
    ${renderPageHero({
      label: t('about.label'),
      title: t('about.title'),
      intro: t('about.intro'),
      kicker: 'Positioning',
      stack: ['Engineering studio', 'Product thinking', 'Precise execution'],
    })}
    <section class="section">
      <div class="container editorial-grid">
        <div class="editorial-copy animate-on-scroll">
          <p class="section-kicker editorial-tab">${t('about.why')}</p>
          <h2 class="section-title">A company site should feel as intentional as the products we build.</h2>
          <div class="editorial-body">
            <p class="section-intro">${t('about.body.p1')}</p>
            <p class="section-intro">${t('about.body.p2')}</p>
            <p class="section-intro">${t('about.body.p3')}</p>
            <p class="section-intro">If you are looking for a software outsourcing partner in Kosova, see how ARKRON approaches <a href="/software-outsourcing-kosovo" class="text-link">software outsourcing in Kosova</a>.</p>
          </div>
        </div>
        <div class="editorial-panels">
          ${ABOUT_PRINCIPLES.map((item) => `
            <article class="process-card animate-on-scroll">
              <h3>${item.title}</h3>
              <p>${item.body}</p>
            </article>
          `).join('')}
        </div>
      </div>
    </section>
    ${renderPageCta({
      label: t('about.label'),
      title: t('about.cta.title'),
      body: t('about.cta.body'),
      buttonLabel: t('about.cta.button'),
    })}
  `;
}
